import { Construction } from 'lucide-react';

interface PlaceholderPageProps {
  title: string;
  description: string;
  stage: string;
}

/**
 * Renders a "coming next stage" placeholder for routes whose feature has
 * not yet been implemented. Keeps the navigation honest about what works
 * today.
 */
export default function PlaceholderPage({ title, description, stage }: PlaceholderPageProps) {
  return (
    <div className="max-w-2xl">
      <h1 className="text-2xl font-bold text-slate-900 mb-1">{title}</h1>
      <p className="text-slate-500 text-sm mb-6">{description}</p>
      <div className="bg-amber-50 border border-amber-200 rounded-xl p-6 flex items-start gap-4">
        <Construction className="h-6 w-6 text-amber-600 flex-shrink-0 mt-0.5" />
        <div>
          <div className="font-semibold text-amber-900 mb-1">Coming in {stage}</div>
          <p className="text-sm text-amber-800">
            The Foundation stage built the data model, security rules, member
            management, fund and category management, and the setup wizard.
            This screen is unlocked in {stage} once the underlying functions
            are in place.
          </p>
        </div>
      </div>
    </div>
  );
}
